import { GroupTypes } from '@/interfaces/enums';
import { IngredientGroupProps } from '@/interfaces/models/product';
import Ingredient from '@/models/ingredient';
import uniqueId from 'lodash.uniqueid';

export default class IngredientGroup {
  public id: string;
  public ingredients: Ingredient[];
  public type: GroupTypes;
  public priority: number;
  public name: string | null;

  public constructor(id: string, ingredients: Ingredient[], type: GroupTypes, priority: number, name: string | null) {
    this.id = id;
    this.ingredients = ingredients;
    this.type = type;
    this.priority = priority;
    this.name = name;
  }

  public static create(type: GroupTypes, priority: number, name: string | null) {
    return new IngredientGroup(uniqueId(), [], type, priority, name);
  }

  public static createByProps(ingredientGroupProps: IngredientGroupProps) {
    return new IngredientGroup(
      ingredientGroupProps.id,
      ingredientGroupProps.ingredients.map(Ingredient.createFromRequest),
      ingredientGroupProps.type,
      ingredientGroupProps.priority,
      ingredientGroupProps.name
    );
  }

  public static createByIngredient(Ingredient: Ingredient, type: GroupTypes, priority: number, name: string | null) {
    return new IngredientGroup(uniqueId(), [Ingredient], type, priority, name);
  }

  get translatedName(): string {
    if (this.name) {
      return this.name;
    } else if (GroupTypes.REQUIRED === this.type) {
      return 'Обязательный';
    } else if (GroupTypes.OPTIONAL === this.type) {
      return 'Дополнительный';
    }

    return this.name = 'Один из';
  }

  get translatedCategoryName(): string {
    if (null !== this.name) {
      return this.name;
    } else if (GroupTypes.REQUIRED === this.type) {
      return 'Обязательные ингредиенты';
    } else if (GroupTypes.OPTIONAL === this.type) {
      return 'Доп. ингредиенты';
    }

    return this.name = 'Один из';
  }
}
